import { useContext, useEffect, useState } from 'react';
import { prettyDate, simpleDate } from '../../../config/dateFormatting';
import { FrontendApi } from '../../../planEatApi/FrontendApi';
import { IBookingContent, IDishContent, ISeatingContent, ISeatingDishContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { DishCreationModal } from '../../../components/modals/DishCreationModal';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { ISelectSeating } from '../../../interface/interface';
import { OfficeContext } from '../../../config/Context';
import { WeekPicker } from '../../../components/ui/WeekPicker';
import toast from 'react-hot-toast';
import { IconButton, makeStyles } from '@material-ui/core';
import { MdAddCircleOutline, MdClose, MdEdit } from 'react-icons/md';
import { resetDish } from '../../../utils/resetObjects';
import { errorToast, successToast } from '../../../utils/crudToast';
import { DATE_QUERY_PARAM, DISH_CO2_IMPACT_DEFAULT } from '../../../constants/constants';
import { useQuery } from '../../../hooks/useQuery';
import { useHistory } from 'react-router-dom';
import { useAdminDateQueryParam } from '../../../hooks/useAdminDateQueryParam';

const useStyles = makeStyles((theme: any) => ({
    dateTitle: {
        color: '#374251',
        fontSize: '80%',
        fontWeight: 700,
    },
    dragAndDropRow: {
        display: 'grid',
        justifyContent: 'space-between',
        alignItems: 'start',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        columnGap: 10
    },
    dragAndDropDayContainer: {
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        minHeight: 250,
        padding: 10,
    },
    dragAndDropDishContainer: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        marginTop: 10,
        paddingTop: 7,
        paddingBottom: 10,
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
        "&:last-child": {
            paddingBottom: 0
        },
        '& > *':{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }
    },
    dishNumberContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 23,
        minWidth: 23,
        maxWidth: 23,
        maxHeight: 23,

        borderRadius: '50%',
        border: '1px #999999 solid',
        color: '#999999',
        marginRight: 10,
    },
    dragAndDropDishDescription: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'normal',
        color: '#374251',
        fontSize: 12,
        maxWidth: '125px'
    },
    addMenuItemContainer: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 8,
        "& > *": {
            marginRight: 5
        },
    },
    addMenuItemText: {
        color: theme.palette.primary.main,
        fontSize: '70%',
        fontWeight: 700
    },
    addMenuIconStyle: {
        color: theme.palette.primary.main,
        height: 23
    },
}));

export const AdminAddMenuArcheive: React.FC = () => {
    // Styling
    const classes = useStyles();
    
    // State
    const [date, setDate] = useState(new Date());
    const [weekDates, setWeekDates] = useState<Date[]>([]);

    const [weekDayIndex, setWeekDayIndex] = useState(0);
    const [weekDishes, setWeekDishes] = useState<IVersionedObject<IDishContent>[][]>([]);
    const [weekDishesView, setWeekDishesView] = useState<any[][]>([]);
    const [hidden, setHidden] = useState(true);

    const [dish, setDish] = useState<IDishContent>({
        id: "",
        name: "name",
        description: "description",
        officeId: "",
        dishTitle: "",
        dishDescription: "",
        foodCategories: [],
        allergens: [],
        co2Impact: DISH_CO2_IMPACT_DEFAULT
    });

    // Context
    const officeContext = useContext(OfficeContext);

    // Entities
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>([]);
    const [bookings,setBookings] = useState<IVersionedObject<IBookingContent>[]>([]);
    const [dishes,setDishes] = useState<IVersionedObject<IDishContent>[]>([]);

    /*Get required info */
    async function getDatabase(){
        if(officeContext?.office){
            planEatApi.getSeatings().then((response) => setSeatings(response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id))).catch((e) => console.log(e))
            planEatApi.getBookings().then((response) => {setBookings(response.data);return response.data}).catch((e) => {console.log(e)})
            planEatApi.getDishes().then((response) => {setDishes(response.data);return response.data}).catch((e) => {console.log(e)})
        }
    }

    /* Update local date if global different than today */
    useAdminDateQueryParam(date,setDate)
    
    useEffect(() => {
        getDatabase();
    }, [officeContext?.office && weekDates]);

    useEffect(() => {
        if (hidden) {
            setDish(resetDish)
        }
    }, [hidden])

    useEffect(() => {
        getDistinctDishesOnDates()
    },[seatings,bookings,dishes])


    async function getDistinctDishesOnDates()  {
        var tmpWeekDishes: IVersionedObject<IDishContent>[][] = []
        for (let i = 0; i < weekDates.length; i++) {
            if(officeContext?.office){
                await FrontendApi.getDishesOnDate(weekDates[i],seatings,dishes)
                .then((response) => {
                    tmpWeekDishes[i] = response;
                }).catch((e) => {
                    console.log(e)
                })
            }
        }
        setWeekDishes(tmpWeekDishes);
    }

    useEffect(() => {
        if (weekDishes.length === 5) {
            displayWeekDishes();
        }
    }, [weekDishes])

    function postDeleteForDish(dishId:string){
        var dishHaveBookings = false;
        seatings.forEach(seating => {
            seating.content.seatingDishes.forEach(seatingDish => {
                if(seatingDish.dishId=== dishId){
                   bookings.forEach(booking => {
                       if(booking.content.seatingId=== seating.content.id){
                            dishHaveBookings = true;
                       }
                   })
                }
            })
        })

        planEatApi.postDeleteForDish(dishId)
        .then(response => {
            toast.success("Dish deleted");
            getDatabase()
        })
        .catch(e => {
            console.log(e);
        })
    }

    function displayWeekDishes() {
        var tmpWeekDishesView: any[][] = []

        weekDishes.forEach((weekDish, i) => {
            tmpWeekDishesView[i] = []
            weekDish.forEach((dish, j) => {
                tmpWeekDishesView[i].push(
                    <div className={classes.dragAndDropDishContainer}>
                        <div>
                            <div className={classes.dishNumberContainer}>
                                {j + 1}
                            </div>
                            <div className={classes.dragAndDropDishDescription}>
                                {dish.content.dishTitle}
                            </div>
                        </div>
                        <div>
                            <IconButton size='small' onClick={() => { setDish(dish.content); setWeekDayIndex(i); setHidden(false) }}>
                                <MdEdit />
                            </IconButton>
                            <IconButton size='small' onClick={() => {postDeleteForDish(dish.content.id)}}>
                                <MdClose />
                            </IconButton>
                        </div>

                    </div>
                )
            })
            // Add menu item button
            tmpWeekDishesView[i].push(
                <div className={classes.addMenuItemContainer} onClick={() => { setHidden(false); setWeekDayIndex(i) }}>
                    <MdAddCircleOutline className={classes.addMenuIconStyle} />
                    <div className={classes.addMenuItemText}>
                        Add Menu Item
                    </div>
                </div>
            )
        })
        setWeekDishesView(tmpWeekDishesView)
    }

    async function postDish(selectSeatings: ISelectSeating[]) {
        dish.officeId = officeContext?.office ? officeContext.office.content.id : ""
        await planEatApi.postDish(dish)
        .then((response) => {
            if (selectSeatings.length > 0) {
                selectSeatings.forEach(async (selectSeating) => {
                    if (selectSeating.selected) {
                        var contains = false;
                        selectSeating.seating.content.seatingDishes.forEach((seatingDish) => {
                            if (seatingDish.dishId === response.data.content.id) {
                                contains = true;
                            }
                        })
                        if (!contains) {
                            var tmpSeatingDishContent: ISeatingDishContent = {
                                dishId: response.data.content.id,
                                menuQuantity: selectSeating.seating.content.seatingCapacity
                            }
                            selectSeating.seating.content.seatingDishes.push(tmpSeatingDishContent)
                        }
                    } else {
                        selectSeating.seating.content.seatingDishes.forEach((seatingDish, index) => {
                            if (seatingDish.dishId === response.data.content.id) {
                                selectSeating.seating.content.seatingDishes.splice(index, 1);
                            }
                        })
                    }
                    // Post seating
                    await planEatApi.postSeating(selectSeating.seating.content)
                })
            }
            setHidden(true)
            successToast("Dish",dish.id)
            setDish(resetDish);
            getDatabase();
        })
        .catch((e) => {
            errorToast("Dish",dish.id)
            console.log(e)
        })
    }

    return (
        <div>
            <div>
                <WeekPicker date={date} setDate={setDate} setWeekDates={setWeekDates} canCalendarPick={true}/>
            </div>
            <div>
                {weekDates.length > 0 && weekDishes.length > 0 &&
                    <div className={classes.dragAndDropRow}>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[0], false, true)}
                            </div>
                            <div>
                                {weekDishesView[0]}
                            </div>
                        </div >
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[1], false, true)}
                            </div>
                            <div>
                                {weekDishesView[1]}
                            </div>
                        </div>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[2], false, true)}
                            </div>
                            <div>
                                {weekDishesView[2]}
                            </div>
                        </div>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[3], false, true)}
                            </div>
                            <div>
                                {weekDishesView[3]}
                            </div>
                        </div>
                        <div className={classes.dragAndDropDayContainer}>
                            <div className={classes.dateTitle}>
                                {prettyDate(weekDates[4], false, true)}
                            </div>
                            <div>
                                {weekDishesView[4]}
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div>
                <DishCreationModal 
                    hidden={hidden} 
                    setHidden={setHidden} 
                    dish={dish} 
                    setDish={setDish} 
                    date={weekDates[weekDayIndex]} 
                    postDish={postDish} 
                    seatings={seatings}
                />
            </div>
        </div>
    );
}